export default __webpack_public_path__ + "static/media/UV Printer Z4 NC GLOBAL.726b9fbc.png";